import actionConsts from '../../constants/actions';

const selfActor = (state = null, action = {}) => {
    switch (action.type) {
        case actionConsts.RECEIVE_INIT_DATA:
            return action.payload.selfActor;
        default:
            return state;
    }
};

export default selfActor;


// WEBPACK FOOTER //
// /src/reducers/uiState/selfActor.js